<template>
   <div class="game-container">
       <div class="game-container-contents">
           <div class="game-game" v-for="item of items">
               <api-image :image="item.Image" :title="item.Title" size="medium" />
               <a :href="item.Link" class="game-heading"><h2>{{ item.Title }}</h2></a>
               <span class="game-text">{{ item.Intro }}</span>
           </div>
       </div>
   </div>
</template>

<script>
    import api_fetch from "../api_fetch";

    export default {
        data() {
          return {
              items: []
          }
        },
        created() {
            api_fetch('api/games').then((data) => {
                data.forEach(item => {
                    this.items.push(item.attributes);
                });
            });
        }
    }
</script>

<style scoped>
    .game-container {
        padding: 0 var(--dl-space-space-fourunits);
    }

    .game-container-contents {
        width: 100%;
        display: grid;
        margin-top: var(--dl-space-space-threeunits);
        flex-direction: column;
        grid-template-columns: 1fr 1fr 1fr;
    }

    .game-game {
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        margin: 0 12px;
    }

    .game-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
        margin-bottom: var(--dl-space-space-unit);
        object-position: center top;
    }

    .game-heading {
        color: var(--dl-color-scheme-black);
        align-self: flex-start;
        margin-top: var(--dl-space-space-halfunit);
        font-weight: 600;
        margin-bottom: var(--dl-space-space-halfunit);
    }

    .game-text {
        color: #595959;
        align-self: flex-start;
    }

    @media (max-width: 767px) {
        .game-game {
            flex-direction: column;
        }

        .game-container {
            padding: 0;
        }

        .game-container-contents {
            grid-template-columns: 1fr 1fr;
        }

        .game-game {
            margin-bottom: var(--dl-space-space-oneandhalfunits);
        }
    }

    @media (max-width: 479px) {
        .game-image {
            height: 24rem;
        }

        .game-container-contents {
            grid-template-columns: 1fr;
        }
    }
</style>
